
import React from "react";
import AwarenessHero from "../components/awarenessPage/AwarenessHero";
import AwareContent from "../components/awarenessPage/AwareContent";



const Awareness = () => {
  return (
   <>
   <AwarenessHero/>
   <AwareContent/>
   </>
  );
};

export default Awareness;
